<mat-drawer-container hasBackdrop>
  <mat-drawer autoFocus="false" #drawer mode="over" position="end" (closed)="close()">
    <app-right-sidebar-container
      [title]="(isEditing ? 'Update' : 'Create') + ' Administrator'"
      [footerSubmitCustomLabel]="isEditing ? 'Update' : 'Create'"
      (cancel)="close()"
      (submit)="onSubmit()"
      [disableSubmit]="form.invalid"
      >
      <form [formGroup]="form" class="provider-content">
        <div class="custom-form-field">
          <label for="name">Administrator Name<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="name" matInput name="name" />
            @if (form.controls['name'].errors?.['required']) {
              <mat-error>Please insert Administrator name</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="email">Email Address<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="email" matInput name="email" type="email" />
            @if (form.controls['email'].errors?.['required']) {
              <mat-error>Please enter Email address</mat-error>
            }
            @if (form.controls['email'].errors?.['email']) {
              <mat-error>Please enter a valid Email address</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="phoneNumber">Phone Number<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input
              formControlName="phoneNumber"
              matInput
              name="phoneNumber"
              type="tel"
              maxlength="10"
              minlength="10"
              [appPhoneInput]="true"
            />
            @if (form.controls['phoneNumber'].errors?.['required']) {
              <mat-error>Please enter Phone number</mat-error>
            }
            @if (form.controls['phoneNumber'].errors?.['invalidPhone']) {
              <mat-error>Phone number must be exactly 10 digits</mat-error>
            }
          </mat-form-field>
        </div>
  <h4 class="section-title">Mailing Address</h4>
        <div class="custom-form-field">
          <label for="mailingStreetAddress">Street Address<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="mailingStreetAddress" matInput name="mailingStreetAddress" />
            @if (form.controls['mailingStreetAddress'].errors?.['required']) {
              <mat-error>Please enter Street address</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="mailingStreetAddressLine2">Street Address Line 2</label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="mailingStreetAddressLine2" matInput name="mailingStreetAddressLine2" />
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="mailingCity">City<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="mailingCity" matInput name="mailingCity" />
            @if (form.controls['mailingCity'].errors?.['required']) {
              <mat-error>Please enter City</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="mailingStateId">State<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <mat-select formControlName="mailingStateId" name="mailingStateId">
              <mat-option value="">- Select -</mat-option>
              @for (state of statesList; track state.id) {
                <mat-option [value]="state.id">{{ state.name }}</mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>expand_more</mat-icon>
            @if (form.controls['mailingStateId'].errors?.['required']) {
              <mat-error>Please select a State</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="mailingZipCode">ZIP Code<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input
              formControlName="mailingZipCode"
              matInput
              name="mailingZipCode"
              type="text"    
            />
            @if (form.controls['mailingZipCode'].errors?.['required']) {
              <mat-error>Please enter ZIP code</mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    </app-right-sidebar-container>
  </mat-drawer>
  <mat-drawer-content>
    <div class="pcs-container">
      <div class="pcs-header">
        <h3 class="pcs-title">Administrators</h3>
        @if (isAdmin()) {
          <div class="card-actions">
            <button
              (click)="openRightSidebar()"
              mat-flat-button
              color="primary"
              type="button"
            >
              <mat-icon>add</mat-icon> Create
            </button>
          </div>
        }
      </div>
      <div class="search-filter-container">
  <app-search-sort
    [searchControl]="searchControl"
    [sortForm]="sortForm"
    [sortOptions]="sortOptions"
    (apply)="setSortField()"
    (close)="resetSortField()"
  ></app-search-sort>

  @if (isAdmin() || isSystem()) {
    <div class="show-all-container">
      <mat-checkbox
        name="showAll"
        [(ngModel)]="showAll"
        (change)="onShowAllChange()"
        color="primary"
      >
        Show All
      </mat-checkbox>
    </div>
  }
</div>
      <div class="pro-card column">
        <app-ag-grid-wrapper
          [data]="rowData$"
          [columns]="columnDefs"
          (ready)="onGridReady($event)"
        />
        <mat-paginator
          #paginator
          [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
          [length]="this.totalCount"
          [pageIndex]="this.currentPage"
          [pageSize]="this.pageSize"
          [pageSizeOptions]="pageSettings.pageSizeOptions"
          (page)="handlePageEvent($event)"
          aria-label="Select page"
        >
        </mat-paginator>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>